import React from 'react';
import { Card, Tag, Typography, Empty } from 'antd';
import { CalendarOutlined, FileTextOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Text, Title } = Typography;

const ArchiveItem = ({ archive }) => {
  const monthNames = [
    '一月', '二月', '三月', '四月', '五月', '六月',
    '七月', '八月', '九月', '十月', '十一月', '十二月'
  ];

  if (!archive || archive.posts.length === 0) {
    return (
      <Card className="archive-item">
        <Empty description="暂无归档数据" />
      </Card>
    );
  }

  return (
    <div className="archive-item">
      <div className="archive-header">
        <div className="archive-title">
          <Title level={3} className="archive-year">
            {archive.year}
          </Title>
          <Title level={4} className="archive-month">
            {monthNames[archive.month - 1]}
          </Title>
        </div>
        <Tag className="archive-count" color="blue">
          <FileTextOutlined /> {archive.count} 篇文章
        </Tag>
      </div>
      
      <div className="archive-posts">
        {archive.posts.map(post => (
          <Link key={post.id} to={`/post/${post.id}`}>
            <div className="archive-post-item">
              <div className="archive-post-title">
                {post.title}
              </div>
              <div className="archive-post-meta">
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  <CalendarOutlined /> {new Date(post.date).toLocaleDateString()}
                </Text>
                {post.tags.slice(0, 2).map(tag => (
                  <Tag key={tag} size="small" style={{ marginLeft: 8 }}>
                    {tag}
                  </Tag>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ArchiveItem;